import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { RadioGroup, Radio, FormControlLabel } from '@material-ui/core';
import MText from './MText';
import Colours from '../../styles/colours';
import { IsEmpty } from '../../common/checks';

const RadioBtnSelect = (props) => (
  <RadioGroup
    row
    className={props.className}
    value={props.value}
    onChange={(e) => props.onChange(e.target.value)}
  >
    {
      _.map(props.options, (option) => (IsEmpty(option) ? <></> : (
        <FormControlLabel
          key={`${String(option.label)}-${String(option.value)}`}
          className={!IsEmpty(props.radioWrapperClassName) ? props.radioWrapperClassName : 'mr-5'}
          value={option.value || ''}
          disabled={props.disabled}
          control={<Radio style={props.radioStyle} color={option.color || props.defaultColor} />}
          label={(
            <>
              <MText text={option.label || option.value} size={props.textSize} style={props.labelStyle} />
              <MText text={option.subLabel} colour={Colours.Gray} size={props.textSize - 2} />
            </>
          )}
        />
      )))
    }
  </RadioGroup>
);

RadioBtnSelect.propTypes = {
  className:             PropTypes.string,
  disabled:              PropTypes.bool,
  labelStyle:            PropTypes.shape({}),
  radioWrapperStyle:     PropTypes.shape({}),
  radioWrapperClassName: PropTypes.string,
  radioStyle:            PropTypes.shape({}),

  options: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.PropTypes.string,
  })),

  defaultColor: PropTypes.oneOf([
    'secondary', 'primary', 'default',
  ]),

  onChange: PropTypes.func,
  value:    PropTypes.string, // must provide as a string value, so null input must be converted to a string
  textSize: PropTypes.number,
};

RadioBtnSelect.defaultProps = {
  className:             '',
  disabled:              false,
  options:               [],
  defaultColor:          'secondary',
  onChange:              () => {},
  value:                 null,
  textSize:              13,
  labelStyle:            {},
  radioWrapperClassName: '',
  radioWrapperStyle:     {},
  radioStyle:            {},
};

export default RadioBtnSelect;
